class EfEtiquetasPopover {
    static get $inject() {
        return ['$scope', 'gql', '$element', 'Etiquetas']
    }

    constructor($scope, gql, $element, Etiquetas) {
        this.apply = fn => $scope.$apply(fn)
        this.applyAsync = fn => $scope.$applyAsync(fn)
        this.gql = gql
        this.search = ""
        this.selected = new Map()
        this.element = $element

        this.Etiquetas = Etiquetas

        this.isListing = true
        this.focusedIndex = 0
    }

    $onInit() {
        this.searchEtiquetas()
            .then(() => this.scrollToBottom())

        this.ngModelCtrl.$render = () => {
            const value = this.ngModelCtrl.$viewValue

            if (value) {
                value.forEach(val => this.selected.set(val.id, val))
            }
        }

        this.onGlobalKeyDown = $event => {
            this.apply(() => {
                if ($event.altKey && $event.code === 'KeyN') {
                    this.showForm()
                    $event.preventDefault()
                }

                if ($event.key === 'Escape') {
                    if (this.isListing) {
                        this.onClose && this.onClose({ $event })
                    } else {
                        this.showList()
                    }

                }
            })
        }

        this.onGlobalClick = $event => {
            this.apply(() => {
                if (!this.element.context.contains($event.target)) {
                    this.onClose && this.onClose({ $event })
                }
            })
        }

        document.addEventListener('keydown', this.onGlobalKeyDown)
        document.addEventListener('mousedown', this.onGlobalClick)

        this.focusOnInputSearch()
    }

    $onDestroy() {
        document.removeEventListener('keydown', this.onGlobalKeyDown)
        document.removeEventListener('mousedown', this.onGlobalClick)
    }

    searchEtiquetas() {
        return this.promise = this.Etiquetas
            .listEtiquetas(this.empresaId, { filter: { search: this.search }, size: 20 })
            .then(({ etiquetas }) => this.etiquetas = etiquetas)
            .then(() => this.focusedIndex = 0)
            .catch(console.error)
            .finally(() => this.apply())
    }

    selectOrDeselect(etiqueta, index) {
        if (this.selected.has(etiqueta.id)) {
            this.selected.delete(etiqueta.id)
        } else {
            this.selected.set(etiqueta.id, etiqueta)
        }

        this.focusedIndex = index
        this.setViewValue()
        this.focusOnInputSearch()
    }

    setViewValue() {
        const values = Array.from(this.selected.values())

        this.ngModelCtrl.$setViewValue(values)
    }

    onListKeyDown($event) {
        switch ($event.key) {
            case 'ArrowUp':
                return this.focusOnPrevious()
            case 'ArrowDown':
                return this.focusOnNext()
            case 'Enter':
                const focused = this.etiquetas[this.focusedIndex]
                if (focused) {
                    this.selectOrDeselect(focused, this.focusedIndex)
                }
        }
    }

    focusOnPrevious() {
        if (this.focusedIndex !== undefined) {
            this.focusedIndex = this.focusedIndex > 0
                ? this.focusedIndex - 1
                : 0

            this.scrollToFocused()
        }
    }

    focusOnNext() {
        if (this.focusedIndex !== undefined) {
            this.focusedIndex = this.focusedIndex < this.etiquetas.length - 1
                ? this.focusedIndex + 1
                : this.etiquetas.length - 1
        } else {
            this.focusedIndex = 0
        }

        this.scrollToFocused()
    }

    scrollToFocused() {
        setTimeout(() => {
            const etiquetasNode = this.element.context.querySelector('.etiquetas')
            const focused = etiquetasNode.querySelector('.is-focused')

            etiquetasNode.scrollTop = focused.offsetTop
        })
    }

    scrollToBottom() {
        setTimeout(() => {
            this.element.find('> div').context.scrollIntoViewIfNeeded(false)
        })
    }

    showList() {
        this.isListing = true
        this.search = ''

        this.focusOnInputSearch()
    }

    showForm() {
        this.isListing = false
        this.etiqueta = { nome: this.search }

        this.focusOnFormInput()
    }

    focusOnInputSearch() {
        setTimeout(() => {
            this.element.find("ef-search-input input").focus()
        })
    }

    focusOnFormInput() {
        setTimeout(() => {
            this.element.find(".etiqueta-form input").focus()
        })
    }

    createEtiqueta() {
        if (this.form.$valid) {
            this.promise = this.Etiquetas
                .createEtiqueta(this.empresaId, this.etiqueta)
                .then(etiqueta => {
                    this.etiquetas.unshift(etiqueta)
                    this.selectOrDeselect(etiqueta, 0)
                    this.showList()
                })
                .catch(errors => errors.forEach(e => this.handleError(e)))
                .finally(() => this.apply())
        }
    }

    handleError({ key }) {
        switch (key) {
            case 'nome':
                return this.form.nome.$setValidity('alreadyExists', false)
        }
    }

    resetForm() {
        this.form.nome.$setValidity('alreadyExists', true)
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efEtiquetasPopover', {
        controller: EfEtiquetasPopover,
        bindings: {
            empresaId: '<',
            onClose: '&',
            position: '@'
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <div ng-class="{'position-end': $ctrl.position == 'end' }">
                <div ng-if="!$ctrl.isListing">
                    <div class="selector-header">
                        <i 
                            class="back cursor-pointer fa fa-long-arrow-left" 
                            ng-show="$ctrl.onClose" 
                            ng-click="$ctrl.showList()">
                        </i>
                        <i 
                            class="close cursor-pointer fa fa-close" 
                            ng-show="$ctrl.onClose" 
                            ng-click="$ctrl.onClose({$event: $event})">
                        </i>

                        <h4>Nova etiqueta</h4>
                    </div>

                    <form name="$ctrl.form" novalidate ng-submit="$ctrl.createEtiqueta()">
                        <div class="etiqueta-form">
                            <input 
                                name="nome" 
                                class="form-control"
                                placeholder="Informe o nome da etiqueta" 
                                ng-model="$ctrl.etiqueta.nome" 
                                ng-change="$ctrl.resetForm()"
                                required />
                            
                            <div ng-messages="$ctrl.form.nome.$error" ng-if="$ctrl.form.$submitted">
                                <span 
                                    class='help-block txt-color-red font-xs no-margin' 
                                    ng-message="required">Informe um nome para a etiqueta.
                                </span>
                                <span 
                                    class='help-block txt-color-red font-xs no-margin' 
                                    ng-message="alreadyExists">Já existe outra etiqueta com este nome.
                                </span>
                            </div>

                            <ef-color-picker ng-model="$ctrl.etiqueta.cor" name="cor" required></ef-color-picker>
                            <div ng-messages="$ctrl.form.cor.$error" ng-if="$ctrl.form.$submitted">
                                <span 
                                    class='help-block txt-color-red font-xs no-margin' 
                                    ng-message="required">Selecione alguma das cores acima.
                                </span>
                            </div>
                        </div>

                        <div class="selector-footer">
                            <promise-tracker promise="$ctrl.promise" active="isActive">                            
                                <button class="btn btn-primary btn-block" ng-disabled="isActive">
                                    <span ng-hide="isActive">Salvar</span>
                                    <span ng-show="isActive">Salvando...</span>
                                </button>
                            </promise-tracker>
                        </div>
                    </form>                    
                </div>
                <div ng-if="$ctrl.isListing" ng-keydown="$ctrl.onListKeyDown($event)">
                    <div class="selector-header">
                        <i 
                            class="close cursor-pointer fa fa-close" 
                            ng-show="$ctrl.onClose" 
                            ng-click="$ctrl.onClose({$event: $event})">
                        </i>

                        <h4>Selecione uma etiqueta</h4>
                        
                        <ef-search-input ng-model="$ctrl.search" ng-change="$ctrl.searchEtiquetas()" >
                        </ef-search-input>
                    </div>
                    
                    <loading promise="$ctrl.promise">
                        <ul class="etiquetas" ng-show="$ctrl.etiquetas.length">
                            <li 
                                ng-repeat="etiqueta in $ctrl.etiquetas" 
                                ng-class="{'is-selected': $ctrl.selected.has(etiqueta.id), 'is-focused': $index === $ctrl.focusedIndex}"
                                ng-click="$ctrl.selectOrDeselect(etiqueta, $index)">
                                <div>
                                    <ef-etiqueta 
                                        cor="{{etiqueta.cor}}" 
                                        nome="{{etiqueta.nome}}"
                                        descricao="{{etiqueta.descricao}}">
                                    </ef-etiqueta>
                                    <span class="etiqueta-descricao">
                                        {{etiqueta.descricao}}
                                    </span>
                                    <i class="selected-icon fa fa-check"></i>
                                </div>                                
                            </li>
                        </ul>
                        <div class="text-muted etiqueta-not-found" ng-hide="$ctrl.etiquetas.length">
                            <span>Nenhuma etiqueta foi encontrada.</span>
                        </div>
                    </loading>
                    
                    <div class="selector-footer">
                        <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.showForm()">
                            Nova etiqueta <span class="text-muted">(Alt+N)</span>
                        </button>
                    </div>
                </div>
            </div>            
        `
    })
